<div style="text-align: right;">
  <i class="fa fa-window-close" style="font-size:14px; cursor: pointer" (click)="close.click()">
    <button #close style="display:none;" (click)="onNoClick()">
      <!-- <button type="button" #close  style="display:none;" (click)="openFileUploadDialog()"></button> -->
    </button>
  </i>
</div>
<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <form [formGroup]="MailTemplateForm" (ngSubmit)="SendMail()">
            <div class="card-body">

              <div class="card-header card-header-danger">
                <div class="row">
                  <div class="col-md-4">
                    <h6>Compose Mail</h6>
                  </div>
                  <div class="col-md-2" style="text-align: right;">
                    <mat-label>Quick Message </mat-label>
                  </div>
                  <div class="col-md-4">
                    <p-dropdown [options]="mailStatusList" (onChange)="GetMailTemplateForSR(RequestEntityId)"
                      placeholder="--None--" formControlName="MailTemplateName" filter="true" [showClear]="true">
                    </p-dropdown>
                  </div>
                  <div class="col-md-2" style="text-align: right;">
                    <i class="fa fa-paperclip" style="font-size:14px; cursor: pointer" (click)="Attachment.click()">
                      <button type="button" #Attachment style="display:none;" (click)="openFileUploadDialog()"></button>

                    </i>&nbsp;
                    <button type="submit" class="btn-primary1">Send</button>
                  </div>
                </div>
              </div>


            </div>
            <div class="card-body">


              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label><span>To</span></label></div>
                    <div class="col-md-8"> <p-autoComplete formControlName="MailToEmail" placeholder="Add Recipient"
                        [suggestions]="employeeListTO" (completeMethod)="SearchActiveEmployee($event,'TO')"
                        [multiple]="true" field="EmpEmail" [forceSelection]="true" [minLength]="3" size="900"
                        (onSelect)="SetEmployeeDetailsTo($event)">
                      </p-autoComplete> </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label>Cc</label></div>
                    <div class="col-md-8"> <p-autoComplete formControlName="MailCCEmail" placeholder="Add Recipient"
                        [suggestions]="employeeListCC" (completeMethod)="SearchActiveEmployee($event,'CC')"
                        [multiple]="true" field="EmpEmail" [forceSelection]="true" [minLength]="3" size="900"
                        (onSelect)="SetEmployeeDetailsCC($event)"> </p-autoComplete> </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label class="control-label">Bcc</label></div>
                    <div class="col-md-8">
                      <p-autoComplete formControlName="MailBCCEmail" placeholder="Add Recipient"
                        [suggestions]="employeeListBCC" (completeMethod)="SearchActiveEmployee($event,'BCC')"
                        [multiple]="true" field="EmpEmail" [forceSelection]="true" [minLength]="3" size="900"
                        (onSelect)="SetEmployeeDetailsBCC($event)"> </p-autoComplete>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label class="control-label">Subject</label></div>
                    <div class="col-md-8"> <input class="form-control" formControlName="Subject"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-4 control-label"> <label class="control-label">Attachments</label></div>
                    <div class="col-md-8">
                      <table class="table">

                        <tr>
                          <td style="padding: 5px;">
                            <div style="float: left;" *ngFor='let url of LocalAttachments'>
                              <a style="cursor:pointer;color:blue;text-decoration: underline;"
                                (click)="DownloadFile(url)">{{url.AttachmentName}}</a>&nbsp;
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="clearfix"></div> -->
              <div class="row">
                <div class="col-md-12">
                  <ngx-editor-menu [editor]="editor"> </ngx-editor-menu><ngx-editor [editor]="editor"
                    [placeholder]="'Type here...'" formControlName="Body"></ngx-editor>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>